import React, { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const apiUrl1 = process.env.REACT_APP_ASSETS_API_URL;
const apiUrl2 = process.env.REACT_APP_ADMIN_API_URL;
const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const apiVehicleUrl = process.env.REACT_APP_VEHICLE_API_URL;
const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getGateListApi = async () => {
  try {
    const response = await axios.get(apiUrl + `gate/autosuggestion`, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEnabledFieldApi = async (data) => {
  try {
    const response = await axios.post(apiUrl + `get_fields`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getReasonApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `get_vehicle_reason/` + id, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const gateInfoApi = async (data) => {
  try {
    const response = await axios.post(apiUrl + `getGateInfo`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getLocation = async (gateId) => {
  try {
    const response = await axios.get(apiUrl + `gate_location_details/` + gateId, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getResponsiblePersonApi = async (gateId) => {
  try {
    const response = await axios.get(apiUrl + `get_responsible_person/` + gateId, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getCheckList = async (locationId, type) => {
  try {
    const response = await axios.get(apiUrl + `checklist/autosuggestion?type=${type}&location_id=` + locationId, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getMobileNumberBasedVisitor = async (mobileNumber, type) => {
  try {
    const response = await axios.get(apiUrl + `mobile?mobilenumber=${mobileNumber}&type=${type}`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const sendOTPApi = async (data) => {
  try {
    const response = await axios.post(adminApiUrl + `sent_otp`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVehicleBasedVisitor = async (data) => {
  try {
    const response = await axios.post(apiUrl + `get_vehicle_details`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const verifyOTPApi = async (data) => {
  try {
    const response = await axios.post(adminApiUrl + `verify_otp`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response?.data || { success: false, message: "Network Error" };
  } finally {
  }
};

export const createVisitorApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `visitors`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateVisitorApi = async (data) => {
  try {
    const response = await axios.put(apiUrl + `visitors`, data, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getVisitorDetailsApi = async (visitorId) => {
  try {
    const response = await axios.get(apiUrl + `visitors/get/` + visitorId, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getHistoryListApi = async (visitorId, type) => {
  try {
    const response = await axios.get(apiUrl + `get_transaction_history?type=${type}&id=` + visitorId, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const checkListFailsUpdateApi = async (id, status, type) => {
  try {
    const response = await axios
      .post(apiUrl + `approve_failedcheck`, { id: id, status: status, type: type }, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getLocationFilterApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `get_location`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getDepartmentFilterApi = async () => {
  try {
    const response = await axios.get(apiUrl2 + `get_department`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const gateInApprovedCheckListApi = async (id, type) => {
  try {
    const response = await axios
      .post(apiUrl + `failedCheckUpdate`, { id: id, type: type }, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const vehicleGateInApprovedCheckListApi = async (id, type, invoice, remarks) => {
  try {
    const response = await axios
      .post(apiUrl + `failedCheckUpdate`, { id: id, type: type, invoice_number: invoice, remarks: remarks }, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const uploadGateInOutAttachmentApi = async (id, data) => {
  try {
    const response = await axios
      .put(apiUrl + `transaction_images_update/${id}`, data, {
        headers: header,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const gateOutApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `visitors/gate_out`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const queueStatusUpdateApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `queueStatusUpdate`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response;
  } finally {
  }
};

export const scheduleStatusUpdateApi = async (data) => {
  try {
    const response = await axios
      .post(apiUrl + `visitors/schedulestatusupdate`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getFailedCheckList = async (id, type) => {
  try {
    const response = await axios.get(apiUrl + `get_trans_checklist/${id}/${type}`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateExpiryDateApi = async (id, data) => {
  try {
    const response = await axios
      .post(apiUrl + `visitors/update_expiry/` + id, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const reportAnIssueApi = async (data) => {
  try {
    const response = await axios
      .post(adminApiUrl + `report_issue`, data, { headers: header })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("error...", error.response);
        return error.response;
        /* if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
       
        } else {
          console.error("Request failed:", error.message);
        } */
      });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getReportIssueTypeApi = async () => {
  try {
    const response = await axios.get(adminApiUrl + `get_issue_type`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getEVehicleInfoApi = async (data) => {
  try {
    const response = await axios.post(apiVehicleUrl + `get_vehicle_info`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching vehicle info:", err);
    return err.response?.data || { success: false, message: "Network Error" };
  } finally {
  }
};

export const getEDriverInfoApi = async (data) => {
  try {
    const response = await axios.post(apiVehicleUrl + `get_driver_info`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching driver info:", err);
    return err.response?.data || { success: false, message: "Network Error" };
  } finally {
    //
  }
};

export const saveVehicleApi = async (data) => {
  try {
    const response = await axios.post(apiVehicleUrl + `save_vehicle`, data, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error saving vehicle:", err);
    return err.response?.data || { success: false, message: "Network Error" };
  } finally {
    //
  }
};
